import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";

export const GroupAddSchema: FormFieldSchema[] = [
  {
    id: "name",
    label: "그룹 이름",
    placeholder: "그룹 이름을 입력해주세요.",
    type: FormFieldType.Text,
  },
];
